<template>
  <div style="">
    <notifications group="messageTop"
            position="center center"
            :speed="500" />
    <notifications group="messageBottom"
            position="bottom right"
            :speed="500" />
    <common-header :pageName=pageName @onMessage='onMessage' style="margin-bottom:1px;"></common-header>
    <div style="max-width:800px; margin:0 auto;">
      <router-view
        @onMessage='onMessage'
      ></router-view>
    </div>
    <mid-footer></mid-footer>
    <common-footer></common-footer>
    <go-top-button style="position:fixed;bottom:10px;right:10px;z-index:3"></go-top-button>
  </div>
</template>

<script>
import CommonHeader from '../components/common/CommonHeader.vue'
import CommonFooter from '../components/common/CommonFooter.vue'
import MidFooter from '../components/common/MidFooter.vue'
import GoTopButton from '../components/common/GoTopButton.vue'
// @ is an alias to /src
export default {
  name: 'MainFrame',
  components: {
    CommonHeader,
    MidFooter,
    CommonFooter,
    GoTopButton
  },
  data () {
    return {
      pageName: 'home'
    }
  },
  computed: {
  },
  watch :{
    '$route' (to) {
      this.pageName = to.name
    }
  },
  created () {
    this.pageName = this.$route.name
  },
  methods: {
    onMessage (obj) {
      this.$notify({
        group: obj.group,
        type: obj.type,
        title: obj.title,
        text: obj.text
      });
    }
  }
}
</script>